import axios from 'axios';
import AppConfig from "../../../../config/AppConfig";

function getBaseURL() {
  // return process.env.NODE_ENV === "development" ? 'http://flow123456.com' : 'https://flow.51homemoney.com'
  return AppConfig.erp_server
}

const instance = axios.create({
  baseURL: getBaseURL() //+ '/customer/'
});

const ErrorResponse = {code: 400, msg: '网络错误'}

instance.interceptors.request.use(function (config) {
  if(!config.params) config.params = {}
  config.params.login = localStorage.getItem('login')
  config.params.token = localStorage.getItem('token')
  return config;
});

function DateFormat(date) {
  let year = date.getFullYear();
  let month = ("0" + (date.getMonth() + 1)).slice(-2);
  let sdate = ("0" + date.getDate()).slice(-2);
  return year + '-' + month + '-' + sdate
}

function get(url, data, callback) {
  instance.get(url, {params: data}).then(resp => {
    callback(resp.data)
  }).catch(error => {
    ErrorResponse.error = error
    callback(ErrorResponse)
  })
}

function post(url, data, callback) {
  instance.post(url, data).then(resp => {
    callback(resp.data)
  }).catch(error => {
    ErrorResponse.error = error;
    ErrorResponse.url=url;
    ErrorResponse.data=data;
    callback(ErrorResponse)
  })
}
export default class CustomerHttp {
  static getBaseURL(){
    return getBaseURL()
  }
  static get(url, data, callback){
    get(CustomerHttp.enUrl(url), data, callback)
  }
  static post(url, data, callback){
    post(CustomerHttp.enUrl(url), data, callback)
  }
  static enUrl(url){
    let login = localStorage.getItem('login')
    let token = localStorage.getItem('token')
    if(url.indexOf('http')!==-1){
      return url;
    }else {
      if(url.indexOf("?")===-1){
        return getBaseURL()+url+`?login=${login}&token=${token}`
      }else {
        return getBaseURL()+url+`&login=${login}&token=${token}`
      }
    }
  }
  static uploadFile(callback){
    let upload=document.getElementById("uploadFile-9999");
    if(!upload){
      upload=document.createElement('input');
      upload.type="file";
      upload.id="uploadFile-9999";
      upload.style.display="none";
    }
    upload.click();
    upload.onchange=function (e) {
      let formData = new FormData();
      formData.append("file",this.files[0]);
      axios.post(AppConfig.erp_server+'/contract/contract/uploadFile',formData).then(res=>{
        if(res){
          typeof callback==="function"&&callback(res.data.data.path)
        }
      },err=>{

      })

      upload.onchange=undefined;

    }

  }

  static uploadFile2(callback,url,data={}){
    let upload=document.getElementById("uploadFile-9999");
    if(!upload){
      upload=document.createElement('input');
      upload.type="file";
      upload.id="uploadFile-9999";
      upload.style.display="none";
    }
    upload.click();
    upload.onchange=function (e) {
      let formData = new FormData();
      formData.append("file",this.files[0]);
      let data_key=Object.keys(data);

      for(let i=0;i<data_key.length;i++){
        formData.append(data_key[i],data[data_key[i]]);
      }

      url=CustomerHttp.enUrl(url);
      axios.post(url,formData).then(res=>{
        if(res){
          typeof callback==="function"&&callback(res.data.data)
        }
      },err=>{
        console.log(err)
      })

      upload.onchange=undefined;

    }

  }
}



// WEBPACK FOOTER //
// ./src/components/Admin/Customer/common/CustomerHttp.js